export enum YesNo{
    Yes = 1,
    No = 2
}

export const YesNoList = [{ id: true, text: "Yes"}, { id: false, text: "No" }];